import {
  COLLABORATION_INITIAL_LOAD,
  COLLABORATION_SET_MESSAGES_IN_STORE,
  COLLABORATION_SET_ACTIVE_TAG,
  COLLABORATION_UPDATE_CHANNEL,
  COLLABORATION_HAS_NEW_MESSAGES,
  COLLABORATION_CLEAR_NEW_MESSAGES,
  COLLABORATION_SET_MESSAGE_DECORATOR,
  COLLABORATION_SET_HAS_MORE_MESSAGES,
  COLLABORATION_SWITCH_CHANNEL,
  COLLABORATION_UPDATE_USERS,
  COLLABORATION_UPDATE_DIRECT_CHANNELS,
  COLLABORATION_CLEAR_STORE,
  COLLABORATION_SCROLL_TO_BOTTOM,
  COLLABORATION_SET_HIGHLIGHT_MESSAGE,
  COLLABORATION_SET_GLOBAL_LOADER,
  COLLABORATION_SET_MENTION_ID,
  COLLABORATION_SET_REPLY_MESSAGE_ID,
  COLLABORATION_SET_PREPARED_CANVAS,
} from '../actionTypes/collaboration';

export const initialLoadAction = (collaborationData: {
  userList?: any;
  workspace?: any;
  channel?: any;
}) => ({
  type: COLLABORATION_INITIAL_LOAD,
  payload: collaborationData,
});

export const setMessagesInStoreAction = (messages: any) => ({
  type: COLLABORATION_SET_MESSAGES_IN_STORE,
  payload: messages,
});

export const setActiveTagAction = (newActiveTag: string) => ({
  type: COLLABORATION_SET_ACTIVE_TAG,
  payload: newActiveTag,
});

export const updateChannelAction = (channel: {
  channel: any;
  channelView: any;
}) => ({
  type: COLLABORATION_UPDATE_CHANNEL,
  payload: channel,
});

export const hasNewMessagesAction = () => ({
  type: COLLABORATION_HAS_NEW_MESSAGES,
});

export const clearNewMessagesAction = () => ({
  type: COLLABORATION_CLEAR_NEW_MESSAGES,
});

export const setMessageDecoratorAction = (decorator: any) => ({
  type: COLLABORATION_SET_MESSAGE_DECORATOR,
  payload: decorator,
});

export const setHasMoreMessagesAction = (hasMoreMessages: boolean) => ({
  type: COLLABORATION_SET_HAS_MORE_MESSAGES,
  payload: hasMoreMessages,
});

export const switchChannelAction = (channelId: string) => ({
  type: COLLABORATION_SWITCH_CHANNEL,
  payload: channelId,
});

export const updateUsersAction = (userList: any) => ({
  type: COLLABORATION_UPDATE_USERS,
  payload: userList,
});

export const updateDirectChannelsAction = (directChannels: any) => ({
  type: COLLABORATION_UPDATE_DIRECT_CHANNELS,
  payload: directChannels,
});

export const clearStoreAction = () => ({
  type: COLLABORATION_CLEAR_STORE,
});

export const scrollToBottomAction = (state: boolean) => ({
  type: COLLABORATION_SCROLL_TO_BOTTOM,
  payload: state,
});

export const setHighlightMessageAction = (messageId: string) => ({
  type: COLLABORATION_SET_HIGHLIGHT_MESSAGE,
  payload: messageId,
});

export const setGlobalLoaderAction = (loadingState: boolean) => ({
  type: COLLABORATION_SET_GLOBAL_LOADER,
  payload: loadingState,
});

export const setMentionIdAction = (mentionId: string) => ({
  type: COLLABORATION_SET_MENTION_ID,
  payload: mentionId,
});

export const setReplyMessageIdAction = (replyMessageId: string) => ({
  type: COLLABORATION_SET_REPLY_MESSAGE_ID,
  payload: replyMessageId,
});

export const setPreparedCanvasAction = (canvas: any) => ({
  type: COLLABORATION_SET_PREPARED_CANVAS,
  payload: canvas,
});
